import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-cream-dark py-16 border-t border-cream/10" data-id="element-108">
      <div className="max-w-7xl mx-auto px-6" data-id="element-109">
        <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-110">
          <div data-id="element-111">
            <div className="font-serif text-xl font-semibold tracking-wide text-white mb-6" data-id="element-112">
              DUBAI BEAUTY
              <br data-id="element-113" />
              <span className="text-sm font-sans font-normal tracking-[0.2em] text-cream-dark uppercase" data-id="element-114">
                Advisory
              </span>
            </div>
            <p className="text-sm font-light leading-relaxed max-w-md" data-id="element-115">
              Professional guidance for investors and founders looking to launch
              or acquire a beauty business in Dubai. Turnkey support from
              concept to opening.
            </p>
          </div>

          <div className="text-xs font-light leading-relaxed text-cream-dark/60" data-id="element-116">
            <h5 className="text-white font-medium mb-4 text-sm" data-id="element-117">
              About Our Services
            </h5>
            <p data-id="element-118">
              If you are looking to buy a beauty business in Dubai, purchase a
              salon, open an aesthetic clinic, invest in a spa or launch a
              turnkey beauty concept in the UAE, we can help you make an
              informed decision. Our service supports investors and
              entrepreneurs with beauty business acquisition, salon setup,
              clinic launch strategy, financial planning, business model
              analysis and operational roadmap development in Dubai.
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-cream/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-light text-cream-dark/60" data-id="element-119">
          <p data-id="element-120">
            &copy; {new Date().getFullYear()} Dubai Beauty Advisory. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-121">
            <a href="/legal" className="hover:text-white transition-colors" data-id="element-122">
              Privacy Policy
            </a>
            <a href="/legal" className="hover:text-white transition-colors" data-id="element-123">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}